import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  activateLanguage,
  defaultLanguageCountry
} from '../../utils/languageSupport';
import RecommendedContentComponent from './RecommendedContentComponent';

const RecommendedContent = (props) => {
  const { language } = props;
  const { recommendedContent, bannerBoxData } = useSelector(
    (state) => state.productData
  );

  useEffect(() => {
    activateLanguage(language);
  }, [language]);

  return (
    <I18nProvider i18n={i18n}>
      <RecommendedContentComponent
        bannerBoxData={bannerBoxData}
        recommendedContent={recommendedContent}
      />
    </I18nProvider>
  );
};

RecommendedContent.propTypes = {
  /**
   * The language for the UI and caas document. Must be in locale format i.e., en-US
   */
  language: PropTypes.string
};

RecommendedContent.defaultProps = {
  /**
   * Default language parameter (en-US)
   */
  language: defaultLanguageCountry
};

export default RecommendedContent;
